export const SET_DOCUMENT_TITLE = 'setDocumentTitle'
